export const routePaths = {
  home: '/',
  snakesAndLadders: '/snakes-and-ladders',
  chessboard: '/chessboard',
  rockPaperScissors: '/rock-paper-scissors',
  cards: '/cards',
  twentyFortyEight: '/2048',
  whatsAppChat: '/whatsapp-chat',
  404: '/404',
};
